module.exports = __webpack_public_path__ + "img/file-lock-02.25ade9d5.svg";